import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';

const programs = [
  {
    id: 'quran',
    tab: "📖 Qur'an",
    badge: "MASQUDE QUR'AN",
    title: "Literasi Qur'an untuk Umat",
    desc: "Program distribusi Al-Qur'an berkualitas dan edukasi Qur'an berbasis nilai melalui platform HikmahQu — menjangkau jamaah, santri, dan penerima manfaat lembaga.",
    list: [
      "Distribusi Al-Qur'an berkualitas ke lembaga mitra",
      "Platform HikmahQu untuk edukasi dan tadabbur",
      "Al-Qur'an khusus penghafal kolaborasi SEJUQ",
      "Program hikmah dan kajian interaktif",
    ],
    highlights: [
      { icon: '📗', text: "Al-Qur'an Reguler & Premium" },
      { icon: '📱', text: 'Platform HikmahQu Digital' },
      { icon: '🎓', text: 'Program Edukasi Hafidz' },
    ],
  },
  {
    id: 'halal',
    tab: '🥩 Halal',
    badge: 'MASQUDE HALAL',
    title: 'Ekosistem Halal dari Kandang ke Meja',
    desc: 'Program edukasi dan sertifikasi sembelih halal bersertifikat BNSP untuk lembaga keislaman — memastikan standar halal yang terjamin dari sumber hingga konsumsi.',
    list: [
      'Pelatihan juru sembelih halal bersertifikat BNSP',
      'Roadshow edukasi ke masjid, pesantren, dan komunitas',
      'Standar halal peternakan NusaQu yang transparan',
      'Konsultasi halal untuk kegiatan lembaga',
    ],
    highlights: [
      { icon: '📜', text: 'Sertifikasi BNSP Resmi' },
      { icon: '🐄', text: 'Peternakan Halal Terstandar' },
      { icon: '🏫', text: 'Roadshow ke 100+ Lembaga' },
    ],
  },
  {
    id: 'green',
    tab: '🌿 Green',
    badge: 'MASQUDE GREEN',
    title: 'Lembaga Hijau & Ketahanan Pangan',
    desc: 'Program penghijauan, ketahanan pangan, dan distribusi pupuk organik untuk lembaga keislaman — menciptakan lingkungan yang sehat dan produktif secara berkelanjutan.',
    list: [
      'Distribusi pupuk organik NusaQu untuk lingkungan lembaga',
      'Program penghijauan dan urban farming',
      'Ketahanan pangan berbasis komunitas masjid',
      'Edukasi pertanian islami dan lingkungan hidup',
    ],
    highlights: [
      { icon: '🌱', text: 'Pupuk Organik NusaQu' },
      { icon: '🥬', text: 'Urban Farming Komunitas' },
      { icon: '♻️', text: 'Program Zero Waste' },
    ],
  },
  {
    id: 'digital',
    tab: '📱 Digital',
    badge: 'MASQUDE DIGITAL',
    title: 'Transformasi Digital Lembaga',
    desc: 'Platform Maslam menghadirkan solusi digital terintegrasi untuk manajemen keuangan, data jamaah, ZISWAF, dan tabungan qurban — semua dalam satu ekosistem.',
    list: [
      'Manajemen keuangan masjid & lembaga digital',
      'Data jamaah, donatur, dan penerima manfaat',
      'Pencatatan ZISWAF dan laporan real-time',
      'Tabungan qurban digital via platform Maslam',
    ],
    highlights: [
      { icon: '💻', text: 'Platform Maslam' },
      { icon: '📊', text: 'Dashboard Real-Time' },
      { icon: '🔐', text: 'Data Aman & Terenkripsi' },
    ],
  },
  {
    id: 'preneur',
    tab: '💼 Preneur',
    badge: 'MASQUDE PRENEUR',
    title: 'Wirausaha Islami Berdampak',
    desc: 'Program pemberdayaan ekonomi melalui jaringan reseller qurban, produk halal, dan pupuk NusaQu — menjadikan lembaga sebagai pusat ekonomi umat yang mandiri.',
    list: [
      'Jaringan reseller qurban sapi dan domba NusaQu',
      'Reseller produk halal dan pupuk organik',
      'Edukasi bisnis islami dan manajemen usaha',
      'Komunitas pengusaha muslim NusaQu',
    ],
    highlights: [
      { icon: '🛍️', text: 'Jaringan Reseller Nasional' },
      { icon: '📈', text: 'Komisi & Insentif Menarik' },
      { icon: '🤝', text: 'Mentoring Bisnis Islami' },
    ],
  },
];

export default function Programs() {
  const [active, setActive] = useState('quran');
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
  const prog = programs.find(p => p.id === active);

  return (
    <section id="program" style={styles.section}>
      <div style={styles.bgOverlay} />

      <div ref={ref} style={{ ...styles.head, opacity: inView ? 1 : 0, transition: 'opacity 0.6s' }}>
        <div><span style={styles.lbl}>5 Program Unggulan</span></div>
        <h2 style={styles.h2}>Program MASQUDE</h2>
        <p style={styles.sub}>Lima program terintegrasi yang dirancang khusus untuk pemberdayaan lembaga keislaman Indonesia</p>
      </div>

      {/* Tabs */}
      <div style={styles.tabs}>
        {programs.map(p => (
          <button key={p.id} style={active === p.id ? styles.tabActive : styles.tab}
            onClick={() => setActive(p.id)}
            onMouseEnter={e => { if (active !== p.id) { e.currentTarget.style.background = 'rgba(240,165,0,0.2)'; e.currentTarget.style.color = 'white'; }}}
            onMouseLeave={e => { if (active !== p.id) { e.currentTarget.style.background = 'rgba(255,255,255,.1)'; e.currentTarget.style.color = 'rgba(255,255,255,.75)'; }}}
          >{p.tab}</button>
        ))}
      </div>

      {/* Pane */}
      <div key={active} className="prog-pane-grid" style={styles.pane}>
        <div style={styles.paneLeft}>
          <span style={styles.badge}>{prog.badge}</span>
          <h2 style={styles.paneTitle}>{prog.title}</h2>
          <p style={styles.paneDesc}>{prog.desc}</p>
          <ul style={styles.list}>
            {prog.list.map(item => (
              <li key={item} style={styles.listItem}>
                <span style={styles.bullet}>✦</span> {item}
              </li>
            ))}
          </ul>
        </div>
        <div style={styles.paneRight}>
          <div style={styles.rightLabel}>Highlight Program</div>
          {prog.highlights.map(h => (
            <div key={h.text} style={styles.hl}>
              <span style={styles.hlIcon}>{h.icon}</span>
              <span style={styles.hlText}>{h.text}</span>
            </div>
          ))}
          <a href="#kontak" style={styles.ctaBtn}
            onClick={e => { e.preventDefault(); document.querySelector('#kontak')?.scrollIntoView({ behavior: 'smooth' }); }}
          >Daftar Program Ini →</a>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: '6rem 5%', background: 'var(--coklat)',
    position: 'relative', overflow: 'hidden',
  },
  bgOverlay: {
    position: 'absolute', inset: 0,
    background: 'linear-gradient(180deg, rgba(0,0,0,.15), transparent 40%)',
    pointerEvents: 'none',
  },
  head: { textAlign: 'center', marginBottom: '2.5rem', position: 'relative', zIndex: 2 },
  lbl: {
    display: 'inline-block', background: 'var(--kuning)', color: 'var(--coklat)',
    padding: '0.28rem 0.95rem', borderRadius: '2rem', marginBottom: '0.8rem',
    fontSize: '0.72rem', fontWeight: 800, letterSpacing: '3px', textTransform: 'uppercase',
  },
  h2: {
    fontFamily: 'Lora, serif', fontSize: 'clamp(1.7rem, 3.5vw, 2.7rem)',
    fontWeight: 700, color: 'var(--kuning2)', marginBottom: '0.8rem',
  },
  sub: { color: 'rgba(255,255,255,.6)', fontSize: '0.97rem', maxWidth: '600px', margin: '0 auto' },
  tabs: {
    display: 'flex', justifyContent: 'center', gap: '0.5rem',
    flexWrap: 'wrap', marginBottom: '2.5rem', position: 'relative', zIndex: 2,
  },
  tab: {
    background: 'rgba(255,255,255,.1)', border: '1.5px solid rgba(255,255,255,.15)',
    color: 'rgba(255,255,255,.75)', padding: '0.5rem 1.2rem', borderRadius: '2rem',
    fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '0.84rem', fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.25s',
  },
  tabActive: {
    background: 'var(--kuning)', border: '1.5px solid var(--kuning)',
    color: 'var(--coklat)', padding: '0.5rem 1.2rem', borderRadius: '2rem',
    fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '0.84rem', fontWeight: 700,
    cursor: 'pointer', transition: 'all 0.25s',
    boxShadow: '0 4px 16px rgba(240,165,0,0.4)',
  },
  pane: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: '3rem', alignItems: 'center',
    maxWidth: '980px', margin: '0 auto',
    position: 'relative', zIndex: 2,
    animation: 'fadeUp 0.4s ease',
  },
  paneLeft: {},
  badge: {
    display: 'inline-block', background: 'var(--kuning)', color: 'var(--coklat)',
    padding: '0.22rem 0.85rem', borderRadius: '2rem',
    fontSize: '0.72rem', fontWeight: 800, letterSpacing: '2px',
    textTransform: 'uppercase', marginBottom: '0.75rem',
  },
  paneTitle: {
    fontFamily: 'Lora, serif', fontSize: '2.1rem',
    fontWeight: 700, color: 'var(--kuning2)', marginBottom: '0.75rem',
  },
  paneDesc: { color: 'rgba(255,255,255,.75)', fontSize: '0.93rem', lineHeight: 1.8, marginBottom: '1.4rem' },
  list: { listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.65rem' },
  listItem: { display: 'flex', alignItems: 'flex-start', gap: '0.65rem', color: 'rgba(255,255,255,.85)', fontSize: '0.88rem', lineHeight: 1.5 },
  bullet: { color: 'var(--kuning2)', fontSize: '0.65rem', marginTop: '0.35rem', flexShrink: 0 },
  paneRight: {
    background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.12)',
    borderRadius: '16px', padding: '1.8rem',
  },
  rightLabel: { color: 'rgba(255,255,255,.5)', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '0.9rem' },
  hl: {
    display: 'flex', alignItems: 'center', gap: '0.75rem',
    background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.08)',
    borderRadius: '8px', padding: '0.7rem 0.95rem', marginBottom: '0.55rem',
  },
  hlIcon: { fontSize: '1.25rem' },
  hlText: { fontSize: '0.86rem', color: 'rgba(255,255,255,.8)', fontWeight: 500 },
  ctaBtn: {
    display: 'inline-block', marginTop: '1.2rem',
    background: 'var(--kuning)', color: 'var(--coklat)',
    padding: '0.75rem 1.5rem', borderRadius: '8px',
    fontSize: '0.88rem', fontWeight: 700, textDecoration: 'none',
    transition: 'all 0.25s',
  },
};
